// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d1fcb317","171":"4d20edfe"}[chunkId] + ".chunk.js";
};